import { getConfig } from '@shared/lib/config';
import { Tag } from 'antd';

/**
 * Бейдж текущего окружения в шапке.
 *
 * Не показываем `prod` — там бейдж только зрительный шум. В `dev` и `test`
 * показываем чтобы исключить случайную работу не в том окружении.
 */
export function EnvBadge() {
  const env = getConfig().env;
  if (env === 'prod') return null;
  const color = env === 'test' ? 'gold' : 'blue';
  return (
    <Tag color={color} style={{ marginInlineStart: 8, fontWeight: 600, letterSpacing: 0.5 }}>
      {env.toUpperCase()}
    </Tag>
  );
}
